// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1T429","addWidgetButton":"Header_addWidgetButton__kxC5a","dashboardTabs":"Header_dashboardTabs__39u-7","active":"Header_active__3SsqD"};